import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  constructor(public oidcSecurityService: OidcSecurityService) {}

  ngOnInit() {
    this.oidcSecurityService.checkAuth().subscribe(
      () => this.oidcSecurityService.authorize(),
      () => this.oidcSecurityService.logoff().subscribe({
        next: () => {
          console.log('Logoff initiated');
        },
        error: (err) => {
          console.error('Logoff error', err);
        }
      }),
    );
  }
}
